{
  "staff-selection-dialog": {
    "buttons": {
      "close": "Zurück",
      "select": "Auswählen",
      "selected": "Ausgewählt"
    },
    "text": {
      "title": "Personalauswahl",
      "first-available": "Erste verfügbare Mitarbeiter"
    }
  }
}
